// src/components/LineChart.js
import React from 'react';

import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(Title, Tooltip, Legend, ArcElement, ChartDataLabels);

const DonutChart = ({ data, options }) => {
   
    return (
      <div className='d-flex justify-content-center align-items-center' style={{ width: '100%', height: '160px' }}>
        <Doughnut data={data} options={options} />
      </div>
    );
  };
  
export default DonutChart;
